import { Link } from 'react-router';
import { Brand } from '../components/Brand.js';

export function DeleteAccountPage() {
  return (
    <div className="legal-page account-deletion-page">
      <header>
        <Brand />
        <Link to="/">Back</Link>
      </header>
      <main>
        <p className="eyebrow">Account control</p>
        <h1>Delete your Bikepacking Live account.</h1>
        <p>
          Sign in with the email address used for Bikepacking Live, open your data controls, and
          choose <strong>Permanently delete account</strong>. You will confirm with a new email code
          before deletion is scheduled.
        </p>
        <Link className="button" to="/signin?returnTo=%2Fapp%2Fdata">
          Sign in to delete account
        </Link>
        <h2>What is deleted</h2>
        <p>
          Deletion immediately stops live sharing and removes access to your account. Your profile,
          trips, stages, precise routes, sharing links, devices, and service records tied to the
          account are deleted under the retention schedule stated in the privacy notice. Encrypted
          backups expire on their documented rotation schedule.
        </p>
        <h2>Delete trip data without deleting your account</h2>
        <p>
          Sign in, open <strong>Data controls</strong>, choose the trip you want to remove, and
          confirm <strong>Permanently delete trip</strong>. This deletes that trip's stages, precise
          route, live-sharing links, and associated viewer comments without closing your Bikepacking
          Live account. Export the trip first if you want to keep a copy.
        </p>
        <Link className="button button-secondary" to="/signin?returnTo=%2Fapp%2Fdata">
          Sign in to manage trip data
        </Link>
        <p>
          Primary trip and location data is deleted within 30 days. Encrypted backup copies expire
          within 90 days and are not restored for ordinary product use.
        </p>
        <h2>If you cannot sign in</h2>
        <p>
          Email <a href="mailto:contact@ahmedkhelifi.com">contact@ahmedkhelifi.com</a> from the
          address on the account. Include your Support ID if you have it. Support will verify the
          request before taking action and will never ask for a sign-in code.
        </p>
        <p>
          Cancel membership before deleting the account. RevenueCat customer data is also erased,
          but that process cannot reliably cancel every App Store, Google Play, or web-provider
          subscription. Use the store or billing portal first if you do not want it to renew.
        </p>
      </main>
    </div>
  );
}
